// src/components/ui/label.jsx
import React from "react";

const Label = React.forwardRef(
  ({ className, children, htmlFor, ...props }, ref) => (
    <label
      ref={ref}
      className={`text-sm font-medium leading-none ${className || ""}`}
      htmlFor={htmlFor}
      {...props}
    >
      {children}
    </label>
  )
);

Label.displayName = "Label";

export { Label };
